/* Pure Lust — Bundle PDP behavior
 * Sticky CTA, FAQ accordion, sequential add-to-cart.
 */
(function () {
  function init() {
    initStickyBar();
    initFaq();
    initBundleAdd();
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-pl-bundle-sticky]');
    var hero = document.querySelector('.pl-bundle__hero');
    var closer = document.querySelector('[data-pl-bundle-closer]');
    if (!bar || !hero) return;

    function update() {
      var heroRect = hero.getBoundingClientRect();
      var heroBottom = heroRect.top + heroRect.height;
      // Show once the hero is roughly 80% scrolled past
      var triggerY = heroRect.height * 0.2;
      var shouldShow = heroBottom < triggerY;

      // Hide near closer (so we don't double-CTA the user at the end)
      if (closer) {
        var closerRect = closer.getBoundingClientRect();
        if (closerRect.top < window.innerHeight * 0.6) {
          shouldShow = false;
        }
      }

      if (shouldShow) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initFaq() {
    var toggles = document.querySelectorAll('[data-pl-faq-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pl-bundle__faq-item');
        if (!item) return;
        var open = item.hasAttribute('data-pl-faq-open');
        if (open) {
          item.removeAttribute('data-pl-faq-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.setAttribute('data-pl-faq-open', '');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initBundleAdd() {
    var btns = document.querySelectorAll('[data-pl-bundle-add]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var raw = btn.getAttribute('data-variant-ids') || '';
        var ids = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (!ids.length) return;

        // Mirror state on all add-buttons so user sees feedback wherever they are
        setAllState('loading');
        addSequentially(ids.slice(), [], []).then(function (result) {
          var added = result.added;
          var skipped = result.skipped;
          if (added.length === 0) {
            setAllState('');
            showNotice('Geen producten beschikbaar — probeer later opnieuw.');
            return;
          }
          setAllState('added');
          updateCartCount();
          if (skipped.length > 0) {
            showNotice(skipped.length === 1
              ? 'Eén product was uitverkocht en is overgeslagen — de rest zit in je winkelmand.'
              : skipped.length + ' producten waren uitverkocht en zijn overgeslagen — de rest zit in je winkelmand.');
          }
          setTimeout(function () {
            window.location.href = '/cart';
          }, skipped.length > 0 ? 2400 : 900);
        });
      });
    });
  }

  function setAllState(state) {
    document.querySelectorAll('[data-pl-bundle-add]').forEach(function (b) {
      if (state) {
        b.setAttribute('data-state', state);
      } else {
        b.removeAttribute('data-state');
      }
    });
  }

  function addSequentially(remaining, added, skipped) {
    if (remaining.length === 0) {
      return Promise.resolve({ added: added, skipped: skipped });
    }
    var id = remaining.shift();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
    .then(function (r) {
      if (r.ok) {
        added.push(id);
      } else {
        skipped.push(id);
      }
      return addSequentially(remaining, added, skipped);
    })
    .catch(function () {
      skipped.push(id);
      return addSequentially(remaining, added, skipped);
    });
  }

  function showNotice(msg) {
    var n = document.createElement('div');
    n.className = 'pl-bundle__notice';
    n.textContent = msg;
    document.body.appendChild(n);
    requestAnimationFrame(function () { n.classList.add('is-visible'); });
    setTimeout(function () {
      n.classList.remove('is-visible');
      setTimeout(function () { n.remove(); }, 400);
    }, 3500);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
